const defaultState = {
  isexpanded: false,
  error: '',
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'SIDER_EXPANDED': {
      return {
        ...state,
        isexpanded: true,
      };
    }
    case 'SIDER_COLLAPSE': {
      return {
        ...state,
        isexpanded: false,
      };
    }
    default:
      return state;
  }
};
